import state from "./state";

export default {
    setRestaurantesArray(state, r) {
        state.restaurantesArray = r;
    },
    setRestaurantesTodosArray(state, r) {
        state.restaurantesTodosArray = r;
    },
    setRestaurantesDirectorio(state, r) {
        state.restaurantesDirectorio = r;
    },
    resetRestaurantes(state) {
        state.restaurantesArray = [];
    },
    setOrdenadoresRest(state, pc) {
        state.ordenadoresRest = pc;
    },
    setImpresorasRest(state, i) {
        state.impresorasRest = i;
    },
    setPedidosArray(state, ped) {
        state.pedidosArray = ped;
    },
    setClientesRestaurante(state, c) {
        state.clientesRestaurante = c;
    },
    setModosTpvRest(state, a) {
        state.modosTpvRest = a;
    },
    setConfTpvRest(state, a) {
        let fI = state.confTpvRest.findIndex(cF => cF.id === a.id);
        if (fI > -1) {
            state.confTpvRest[fI].confTpv = a.confTpv
        } else {
            state.confTpvRest.push(a);
        }
    },
    //RESERVAS
    setReservasConfiguracion(state, obj) {
        state.reservasConfiguracion = obj
    }
}